module.exports = __webpack_public_path__ + "img/app-awjd.a4571e4b.webp";